import React, { useState } from "react";
import Style from "./ProductInfoAll.module.scss";
import { separate } from "../../../../../Utils/SeprateNumber/SeprateThreeNumber";
import { Tag, Tooltip } from "antd";
import {
  SwapOutlined,
  ExclamationCircleOutlined,
  CheckCircleOutlined,
  CopyOutlined,
  PictureOutlined,
} from "@ant-design/icons";
import { succToast } from "../../../../../Utils/Toast/Toast";

const ProductInfoAll = ({ data, statusId, Price }) => {
  const [imgErrors, setImgErrors] = useState({});

  if (!data || !data.products || !Array.isArray(data.products)) {
    return (
      <div style={{ padding: "1rem", textAlign: "center", color: "#8c8c8c" }}>
        محصولی یافت نشد.
      </div>
    );
  }

  const handleImgError = (id) => {
    setImgErrors((prev) => ({ ...prev, [id]: true }));
  };

  const copyToClipboard = (text, message = "کپی شد") => {
    if (navigator.clipboard) {
      navigator.clipboard.writeText(String(text));
      succToast(message);
    }
  };

  // Check if any item has changes
  let totalItemsCount = 0;
  let totalProductsPrice = 0;
  let totalProductsFee = 0;
  let changesCount = 0;

  const analyzedProducts = data.products.map((element) => {
    const isReplaced = Boolean(
      element.p_product_id &&
        String(element.p_product_id).trim() !== "0" &&
        String(element.p_product_id).trim() !== "" &&
        String(element.p_product_id) !== String(element.product_id)
    );

    const isPriceChanged = Boolean(
      element.new_price !== undefined &&
        element.new_price !== null &&
        String(element.new_price).trim() !== "" &&
        Number(element.new_price) !== Number(element.price)
    );

    const isCountChanged = Boolean(
      element.new_count !== undefined &&
        element.new_count !== null &&
        String(element.new_count).trim() !== "" &&
        Number(element.new_count) !== Number(element.count)
    );

    const isUnavailable = Boolean(
      element.availability === "0" ||
        element.availability === 0 ||
        (element.new_count !== undefined && Number(element.new_count) === 0)
    );

    const hasAnyChange =
      isReplaced || isPriceChanged || isCountChanged || isUnavailable;

    if (hasAnyChange) {
      changesCount++;
    }

    const effectivePrice =
      element.new_price !== undefined &&
      element.new_price !== null &&
      String(element.new_price).trim() !== ""
        ? Number(element.new_price)
        : Number(element.price || 0);

    const effectiveCount =
      element.new_count !== undefined &&
      element.new_count !== null &&
      String(element.new_count).trim() !== ""
        ? Number(element.new_count)
        : Number(element.count || 0);

    const originalPrice = Number(element.price || 0);
    const originalCount = Number(element.count || 0);

    const rowTotal = effectivePrice * effectiveCount;
    const originalRowTotal = originalPrice * originalCount;

    const unitFee = Number(element.product_fee || 0);
    const rowFee = unitFee * effectiveCount;

    totalItemsCount += effectiveCount;
    totalProductsPrice += rowTotal;
    totalProductsFee += rowFee;

    // Active product ID and link (user: p_product_id is the new id if replaced)
    const activeProductId = isReplaced
      ? element.p_product_id
      : element.product_id;

    return {
      element,
      isReplaced,
      isPriceChanged,
      isCountChanged,
      isUnavailable,
      hasAnyChange,
      effectivePrice,
      effectiveCount,
      originalPrice,
      originalCount,
      rowTotal,
      originalRowTotal,
      unitFee,
      rowFee,
      activeProductId,
    };
  });

  return (
    <div className={Style.productContainer}>
      {changesCount > 0 && (
        <div className={Style.changeNotice}>
          <ExclamationCircleOutlined className={Style.noticeIcon} />
          <span>
            توجه: تامین‌کننده در این بخش برای {changesCount} قلم از محصولات، تغییرات (تغییر قیمت، تعداد، تعویض کالا یا عدم موجودی) اعمال کرده است.
          </span>
        </div>
      )}

      <div className={Style.tableWrapper}>
        <div className={Style.tableHeader}>
          <div className={Style.colImage}>تصویر</div>
          <div className={Style.colInfo}>اطلاعات محصول</div>
          <div className={Style.colCount}>تعداد</div>
          <div className={Style.colPrice}>قیمت واحد</div>
          <div className={Style.colTotal}>مبلغ کل</div>
          <div className={Style.colFee}>کارمزد</div>
          <div className={Style.colStatus}>وضعیت / تغییرات</div>
        </div>

        {analyzedProducts.map((item, index) => {
          const {
            element,
            isReplaced,
            isPriceChanged,
            isCountChanged,
            isUnavailable,
            effectivePrice,
            effectiveCount,
            originalPrice,
            originalCount,
            rowTotal,
            originalRowTotal,
            rowFee,
            activeProductId,
          } = item;

          let rowClass = Style.rowItem;
          if (isUnavailable) {
            rowClass += ` ${Style.rowUnavailable}`;
          } else if (isReplaced) {
            rowClass += ` ${Style.rowReplaced}`;
          } else if (isPriceChanged || isCountChanged) {
            rowClass += ` ${Style.rowChanged}`;
          }

          const hasImgError = imgErrors[activeProductId];

          return (
            <div key={element.product_id || index} className={rowClass}>
              {/* Image */}
              <div className={Style.colImage}>
                <div className={Style.imgWrapper}>
                  {!hasImgError ? (
                    <img
                      src={`https://cdn.barest.ir/product/m/${activeProductId}.jpg`}
                      alt={element.name}
                      onError={() => handleImgError(activeProductId)}
                      loading="lazy"
                    />
                  ) : (
                    <div className={Style.placeholder}>
                      <PictureOutlined style={{ fontSize: "1.2rem" }} />
                    </div>
                  )}
                </div>
              </div>

              {/* Product Info */}
              <div className={Style.colInfo}>
                <a
                  href={`/editproduct/${activeProductId}`}
                  rel="noreferrer"
                  target="_blank"
                  className={Style.productTitle}
                  title="مشاهده و ویرایش محصول"
                >
                  {element.name}
                </a>

                <div className={Style.metaRow}>
                  <span className={Style.idBadge}>
                    شناسه: {activeProductId}
                    <Tooltip title="کپی شناسه">
                      <CopyOutlined
                        onClick={() =>
                          copyToClipboard(activeProductId, "شناسه کپی شد")
                        }
                        style={{
                          marginRight: 4,
                          cursor: "pointer",
                          color: "#1890ff",
                        }}
                      />
                    </Tooltip>
                  </span>
                </div>

                {/* Replacement Details */}
                {isReplaced && (
                  <div className={Style.replacedCard}>
                    <span className={Style.replacedLabel}>
                      <SwapOutlined /> محصول تعویض شده
                    </span>
                    {element.p_name ? (
                      <span className={Style.originalName}>
                        (محصول قبلی: {element.p_name})
                      </span>
                    ) : (
                      <span className={Style.originalId}>
                        (آیدی قبلی: {element.product_id})
                      </span>
                    )}
                  </div>
                )}
              </div>

              {/* Quantity */}
              <div className={Style.colCount}>
                <div className={Style.countBox}>
                  {isCountChanged && (
                    <span className={Style.oldVal}>{originalCount}</span>
                  )}
                  <span
                    className={`${Style.activeCount} ${
                      isCountChanged ? Style.countChanged : ""
                    }`}
                  >
                    {effectiveCount} عدد
                  </span>
                </div>
              </div>

              {/* Unit Price */}
              <div className={Style.colPrice}>
                <div className={Style.priceBox}>
                  {isPriceChanged && (
                    <span className={Style.oldVal}>
                      {separate(originalPrice)}
                    </span>
                  )}
                  <span
                    className={`${Style.activePrice} ${
                      isPriceChanged ? Style.priceChanged : ""
                    }`}
                  >
                    {separate(effectivePrice)}
                    <span className={Style.currency}>تومان</span>
                  </span>
                </div>
              </div>

              {/* Subtotal */}
              <div className={Style.colTotal}>
                <div className={Style.totalBox}>
                  {(isPriceChanged || isCountChanged) && (
                    <span className={Style.oldVal}>
                      {separate(originalRowTotal)}
                    </span>
                  )}
                  <span className={Style.activeTotal}>
                    {separate(rowTotal)}
                    <span className={Style.currency}>تومان</span>
                  </span>
                </div>
              </div>

              {/* Fee */}
              <div className={Style.colFee}>
                <span className={Style.feeValue}>
                  {separate(rowFee)}
                  <span className={Style.currency}>تومان</span>
                </span>
              </div>

              {/* Status & Change Tags */}
              <div className={Style.colStatus}>
                {isUnavailable && <Tag color="error">ناموجود</Tag>}
                {isReplaced && <Tag color="purple">تعویض کالا</Tag>}
                {isPriceChanged && (
                  <Tag
                    color={
                      effectivePrice > originalPrice ? "volcano" : "cyan"
                    }
                  >
                    {effectivePrice > originalPrice
                      ? "افزایش قیمت"
                      : "کاهش قیمت"}
                  </Tag>
                )}
                {isCountChanged && <Tag color="geekblue">تغییر تعداد</Tag>}
                {!item.hasAnyChange && (
                  <Tag color="success" icon={<CheckCircleOutlined />}>
                    تایید شده
                  </Tag>
                )}
              </div>
            </div>
          );
        })}
      </div>

      {/* Summary Footer */}
      <div className={Style.tableFooter}>
        <div className={Style.footerItem}>
          <span className={Style.footerLabel}>تعداد کل اقلام:</span>
          <span className={Style.footerValue}>{totalItemsCount} عدد</span>
        </div>
        <div className={Style.footerItem}>
          <span className={Style.footerLabel}>مجموع فاکتور این فروشگاه:</span>
          <span className={`${Style.footerValue} ${Style.highlightGreen}`}>
            {separate(totalProductsPrice)}
          </span>
          <span className={Style.currency}>تومان</span>
        </div>
        <div className={Style.footerItem}>
          <span className={Style.footerLabel}>مجموع کارمزد این فروشگاه:</span>
          <span className={`${Style.footerValue} ${Style.highlightRed}`}>
            {separate(totalProductsFee)}
          </span>
          <span className={Style.currency}>تومان</span>
        </div>
      </div>
    </div>
  );
};

export default ProductInfoAll;
